import React, { useState } from "react";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import { Formik, Form, Field } from "formik";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import { OutlineTextField, OutlineSelect } from "../../FormikCustoms";
import FormModal from "../../FormModal";
import { validateCpfCnpj } from "./../../../utils/inputValidations";
import DialogMessage from "./../../Dialog";
import useStyles from "./styles";

function ModalData({ open, handleClose, handleSave, reservationTypes, editedData }) {
  const [feedback, setFeedback] = useState({});
  const [openWarningMsg, setOpenWarningMsg] = useState(false)
  const styles = useStyles()

  const handleOnFeedback = () => {
    if (feedback.success) {
      handleOnclose();
    } else {
      setFeedback({});
    }
  };

  /* const handleEditReservationType = () => {
    const id = editedData.id??null;
    return id ? setOpenWarningMsg(true) : '';
  }; */

  const handleOnclose = () => {
    handleClose();
    setFeedback({});
  };

  const savePlant = async (values, setSubmitting) => {
    const operationFeedback = await handleSave(values);
    setSubmitting(false);
    setFeedback(operationFeedback);
  };

  const handleValidate = (values) => {
    const errors = {};
    if (!values.name) {
      errors.name = "Nome da planta precisa ser informado.";
    }else if(values.name.length > 50){
      errors.name = "Nome da planta não deve exceder o máximo de 50 caracteres.";
      errors.error = true
    }else if(values.name.length < 3){
      errors.name = "Nome da planta deve possuir no mínimo 3 caracteres.";
      errors.error = true
    }

    if (!values.document_number) {
      errors.document_number = "CNPJ da planta precisa ser informado.";
    }
    if (values.document_number && !validateCpfCnpj(values.document_number)) {
      errors.document_number = "CNPJ da planta precisa ser válido";
    }
    if (!values.bussiness_type) {
      errors.bussiness_type = "Tipo de negócio precisa ser informado.";
    }
    if (!values.bp_number) {
      errors.bp_number = "Número BP precisa ser informado.";
    }
    return errors;
  };

  const getWarnningMessage = (
    <p className={styles.warnningMessage}>Ao alterar a reserva de cotas, os dados de  Cotas Clientes/Fornecedor serão removidos.</p>
  )

  return (
    <FormModal
      title={editedData.id ? "Editar planta" : "Adicionar planta"}
      open={open}
      handleClose={handleOnclose}
    >
      {!Object.keys(feedback).length ? (
        <Formik
          initialValues={{
            id: editedData.id ?? null,
            name: editedData.name ?? "",
            document_number: editedData.document_number ?? "",
            bussiness_type: editedData.bussiness_type ?? "",
            id_reservation_type: editedData.id_reservation_type ?? "1",
            bp_number: editedData.bp_number ?? "",
            allow_editing: editedData.allow_editing ?? false,
          }}
          validate={(values) => handleValidate(values)}
          onSubmit={(values, { setSubmitting }) =>
            savePlant(values, setSubmitting)
          }
        >
          {({ values, setValues, ...props }) => (
            <Form
               data-cy="form-plant"
               id="form-plant"
            >
              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <Field
                    component={OutlineTextField}
                    name="name"
                    data-cy="plant-name"
                    id="plant-name"
                    type="text"
                    value={values.name}
                    label="Nome da planta"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Field
                    component={OutlineTextField}
                    name="bp_number"
                    data-cy="plant-bp-number"
                    id="plant-bp-number"
                    type="text"
                    value={values.bp_number}
                    mask="9999999999"
                    maskplaceholder=""
                    label="Número BP"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Field
                    component={OutlineSelect}
                    data-cy="plant-bussiness-type"
                    id="plant-bussiness-type"
                    name="bussiness_type"
                    label="Tipo de negócio"
                  >
                    <MenuItem value="CASC">CASC</MenuItem>
                    <MenuItem value="FIBI">FIBI</MenuItem>
                  </Field>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Field
                    component={OutlineTextField}
                    name="document_number"
                    data-cy="plant-document-number"
                    id="plant-document-number"
                    type="text"
                    mask="99.999.999/9999-99"
                    value={values.document_number}
                    label="CNPJ"
                  />           
                </Grid>     
                {/* Removed for tests if will have business acceptance, don't clean it for while. */}
                {/* If you must enable it, remember to uncomment the handleEditReservationType function above */}
                {/* <Grid item md={6} xs={12}>
                  <Field
                    component={OutlineSelect}
                    name="id_reservation_type"
                    data-cy="plant-reservation-type"
                    id="plant-reservation-type"
                    label="Reserva de cotas"
                    onClick={() => {handleEditReservationType()}}
                  >
                    {reservationTypes?.map(r => (
                      <MenuItem value={r.id}>{r.name}</MenuItem>
                    ))}
                  </Field>
                </Grid> */}
                <Grid item md={6} xs={12}>
                  <label>                                        
                    <fieldset style={
                      { 
                        borderColor: 'rgba(0, 0, 0, 0.23)', 
                        borderRadius: 4, 
                        minHeight: 64,
                        marginTop: '-9px'
                      }
                    }>
                      <legend>Permitir edição de agendamentos{values.allow_editing}</legend>
                      <Field
                        name="allow_editing"
                        type="checkbox"
                        data-cy="plant-allow"
                        id="plant-allow"
                        checked={values.allow_editing}
                      />
                    </fieldset>
                  </label>
                </Grid>
                <Grid item md={6} xs={0} />
                <Grid item md={6} xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ minWidth: "100%", height:"56px" }}
                    disabled={props.isSubmitting}
                    onClick={props.submitForm}
                    data-cy="plant-save"
                    id="plant-save"
                    size="large"
                  >
                    Salvar
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      ) : (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h5">{feedback.message}</Typography>
          </Grid>
          <Grid item xs={12}>
            <div
              style={{
                display: "flex",
                height: 56,
                justifyContent: "flex-end",
              }}
            >
              <Button
                onClick={handleOnFeedback}
                variant="contained"
                color="primary"
                data-cy="plant-feedback-button"
                id="plant-feedback-button"
                style={{ minWidth: "50%" }}
                size="large"
              >
                {feedback.success ? "Voltar" : "Tentar novamente"}
              </Button>
            </div>
          </Grid>
        </Grid>
      )}
      <DialogMessage 
        isOpen={openWarningMsg}
        subject="Atenção!"
        data-cy="plant-feedback-modal"
        id="plant-feedback-modal"
        closeReadingNotificationDialog={() =>{setOpenWarningMsg(false)}}
        children={getWarnningMessage}
      >
      </DialogMessage>
    </FormModal>
  );
}

ModalData.defaultProps = {
  editedData: {},
};

ModalData.propTypes = {
  reservationTypes: PropTypes.array.isRequired,
  editedData: PropTypes.object,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
};

export default ModalData;
